import { render, staticRenderFns } from "./AdxAndOb.vue?vue&type=template&id=89bac286&scoped=true"
import script from "./AdxAndOb.vue?vue&type=script&lang=js"
export * from "./AdxAndOb.vue?vue&type=script&lang=js"
import style0 from "./AdxAndOb.vue?vue&type=style&index=0&id=89bac286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bac286",
  null
  
)

export default component.exports